import { Card, Text } from '@ksyos/design-system';
import type { IServiceRights } from './ServiceRightStopModal';
import { translateKey } from '../../../../translate';
import { StopServiceGroupLink } from './StopServiceGroupLink';

interface IStopServiceGroupProps extends IServiceRights {
    organizationId: string;
    serviceGroupName: string;
}

export function StopServiceGroup(props: IStopServiceGroupProps) {
    return (
        <Card>
            <Card.Body>
                <Text>{translateKey('carePath.stopServiceGroupText', props.serviceGroupName)}</Text>
            </Card.Body>
            <Card.Footer>
                <StopServiceGroupLink {...props} />
            </Card.Footer>
        </Card>
    );
}
